import { Link, LinkProps } from "@repo/next-utils/router";

export type ProductLinkProps = Omit<LinkProps, "href"> & {
  productName: string;
  productId: number | string;
  fragments?: Record<string, string>;
};

export function ProductLink({
  productId,
  productName,
  fragments,
  ...props
}: ProductLinkProps) {
  let fragmentString = "";
  const name = productName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();

  if (fragments) {
    fragmentString = Object.entries(fragments)
      .map(([key, value]) => `#${key}-${value}`)
      .join("");
  }

  const href = `/product/${name}/${productId}${fragmentString}`;

  return <Link {...props} href={href} />;
}
